;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import CarouselProvider from 'components/ui/CarouselProvider';

import { blockRootProps } from 'utils';

import CarouselShowcase from './CarouselShowcase';

const BlockCarouselShowcase = ({ __typename, anchorId, slides }) => {
    return (
        <div {...blockRootProps(anchorId, __typename)}>
            <CarouselProvider slides={slides}>
                <CarouselShowcase />
            </CarouselProvider>
        </div>
    );
};

BlockCarouselShowcase.propTypes = {
    __typename: PropTypes.string,
    anchorId: PropTypes.string,
    className: PropTypes.string,
    slides: PropTypes.array,
};

export default BlockCarouselShowcase;
